import { QuickLink } from '../../services/CompetitionsService';
import './buscadoresStyle.css'


const CardCompanyComponents = (props: QuickLink) => {
    return (
        <a
            href={props.url}
            target="_blank" 
            rel="noopener noreferrer"
            className="linkCard"
        >
            <div className="containerImgCard">
                <img
                    height="auto"
					width="300px"
                    style={{margin: "16px" }}
                    src={props.imgBanner}
                    alt="Card Image"
                />
            </div>
        </a>
    );
};

export default CardCompanyComponents;